import colorPalette from '../color-palette';

const { info } = colorPalette;

export default {
  MuiDivider: {
    root: {
      width: '45%',
      marginTop: '8px',
      backgroundColor: info.divider,
    },
  },
};
